import { useAppSelector } from '#components/redux/hooks';
import { StateMenu } from '#baseMenu/types/StateMenu';

// @ts-ignore
const useMenuState = (): StateMenu => useAppSelector((state) => state.menu);

export { useMenuState };
